import {Comparison} from './types';

export const SINGLE_CATEGORY = {value: ''};

export const asSingleCategory = ({project, bando}: Comparison) => ({project: {value: project}, bando: {value: bando}});

export const sizes = ({project, bando}: Comparison) => ({project: project.n, bando: bando.n});
